import { render, staticRenderFns } from "./OrderDetailCard.vue?vue&type=template&id=78f551c4&scoped=true&"
import script from "./OrderDetailCard.vue?vue&type=script&lang=js&"
export * from "./OrderDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrderDetailCard.vue?vue&type=style&index=1&id=78f551c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f551c4",
  null
  
)

export default component.exports